import React, { Component } from "react";
import { Tabs, Tab } from "material-ui/Tabs";
import Paper from "material-ui/Paper";
import * as colors from "../constants/colors";
import * as globalStyles from "../constants/styles";
import { changeColor } from "../util/color";
import Standings from "./Standings";
import Schedule from "./Schedule";

export default class League extends Component {
  render() {
    const { division, color } = this.props;
    const backgroundColor = colors[color];
    const tabColor = changeColor(backgroundColor, 0.5);
    const background =
      "linear-gradient(to bottom, " +
      backgroundColor +
      ", " +
      changeColor(backgroundColor, 0.25) +
      " 100px)";
    const promotion = division === 2 || division === 3;
    const relegation = division === 1 || division === 2;
    return (
      <div style={styles.container}>
        <Paper zDepth={2} style={{ background }}>
          <div style={styles.header}>Division {division}</div>
          <Tabs
            contentContainerStyle={styles.content}
            tabItemContainerStyle={styles.tabs}
            inkBarStyle={{ ...styles.activeTab, backgroundColor: tabColor }}
          >
            <Tab label="Tabell">
              <Standings
                division={division}
                promotion={promotion}
                relegation={relegation}
              />
            </Tab>
            <Tab label="Spelschema">
              <Schedule division={division} />
            </Tab>
          </Tabs>
        </Paper>
      </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    flexBasis: 400,
    maxWidth: 500,
    minWidth: 400,
    margin: globalStyles.space
  },
  header: {
    fontSize: globalStyles.titleFontSize,
    color: colors.white,
    padding: globalStyles.space * 2
  },
  content: {
    backgroundColor: colors.white
  },
  tabs: {
    backgroundColor: "transparent"
  },
  activeTab: {
    height: 3
  }
};



// WEBPACK FOOTER //
// ./src/components/League.js